import { useDispatch, useSelector } from "react-redux";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { getProjectsByVisaId } from "../../../../store/Api";
import { useEffect, useState } from "react";
import { CiEdit } from "react-icons/ci";
import Visareturnfromstock from "./visareturnfromstockpopup";
import nodeinstance from "../../../../nodeInstance";
import { RiSearch2Line } from "react-icons/ri";
import { setAppError } from "../../../../store/userSlice";
import { CgSpinner } from "react-icons/cg";

export default function VisaProjectSummary({ projectsByVisaData = [],setApiTrigger}) {
  const token = localStorage.getItem("nodeToken");
  const dispatch = useDispatch();
  const titles = [
    "S.NO",
    "VISA PROVIDER NAME",
    "VISA BLOCK NUMBER",
    "SPONSOR ID",
    "VISA PROFESSION",
    "PROJECT NAME",
    "ALLOCATED",
    "BALANCE",
    "REVERSE",
  ];
  // const {
  //   NoDataFound,
  //   Pagination,
  //   PaginationIndex,
  //   Search,
  //   CountPerPage,
  //   currentList,
  // } = useSearchPagination(projectsByVisaData ? projectsByVisaData : []);

  const [popup, setPopUp] = useState(false);
  const [propData, setPropData] = useState();

  const [search, setSearch] = useState();
  const [isSearch, setIsSearch] = useState(false);
  const filter = (e) => {
    const keyword = e.target.value;
    setIsSearch(true);
    if (keyword !== "") {
      const results = projectsByVisaData.filter((user) => {
        // Define an array of keys you want to search in
        const keysToSearch = ["project_name", "visa_block_number", "sponsor_id","visa_profession","visa_provider_name"]; // Add more keys as needed
        // Check if any of the keys contain the keyword
        return keysToSearch.some((key) =>
          user[key]?.toLowerCase().includes(keyword.toLowerCase())
        );
      });
      setSearch(results);
    } else {
      setSearch(projectsByVisaData);
      // If the text field is empty, show all users
    }
  };

  console.log("searchWordssearchWords..........f.f.f.f.f.f.f.f.f", search);

  const [downloadLoading, setDownloadLoading] = useState(false);

  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/dashboard/visa-stock/downloaProjectExcel/${projectsByVisaData && projectsByVisaData[0]?.vrf_id}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `PROJECT WISE SUMMARY`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  useEffect(() => {
    setSearch(projectsByVisaData);
  }, [projectsByVisaData]);
  return (
    <>
      <div className="overflow-x-auto mt-5 ml-5" style={{ height: "400px" }}>
        <div className="flex flex-wrap gap-2 mb-1 items-center">
          <h2>VISA ALLOCATION PROJECT WISE SUMMARY</h2>
          {/* <Search
            keywords={[
              "visa_provider_name",
              "visa_block_number",
              "sponsor_id",
              "visa_profession",
              "project_name"
            ]}
            // setSearchWords={setSearchWords}
            className="ml-auto text-lg p-3"
          /> */}
          {/* <input  className="ml-auto text-lg p-3" /> */}

          <input
            type="search"
            className={`input input-sm h-10 max-w-xs pl-8 w-full input-bordered focus:outline-none uppercase ml-auto text-lg p-2`}
            placeholder={"Enter to search"}
            // onChange={(e) => {
            //   searchHandler(e, searchKey || keywords, setSearchWords);
            // }}
            onChange={filter}
          />

          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
            onClick={() => downloadFile()}
            // disabled={downloadLoading || list?.isLoading}
          >
            <p>Download</p>
            {downloadLoading && <CgSpinner className="animate-spin" />}
          </button>

          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-100">
              <tr>
                {titles?.map((columnName, index) => (
                  <th
                    key={index}
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider font-semibold"
                  >
                    {columnName}
                  </th>
                ))}
              </tr>
            </thead>
            {search?.length < 0 ? (
              <tbody className="bg-white divide-gray-10">
                <h1>No Data found</h1>
              </tbody>
            ) : (
              <tbody className="bg-white divide-gray-10">
                {search?.map((listItem, index) => (
                  <tr key={index}>
                    <td className="px-6 py-4 whitespace-nowrap">{index + 1}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.visa_provider_name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.visa_block_number}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.sponsor_id}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.visa_profession}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.project_name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.allocated}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {parseInt(listItem.balance)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <button
                        className="rounded-md bg-white p-2 text-sm text-black border border-gray-500 mr-3"
                        style={{ fontSize: "1rem" }}
                        onClick={() => {
                          setPopUp(true);
                          setPropData(listItem);
                        }}
                      >
                        <CiEdit size={"1rem"} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
          {/* {currentList?.length > 0 ? <Pagination /> : ""} */}
          {popup ? (
            <Visareturnfromstock
              showPromptElement={popup}
              setPopUpopen={setPopUp}
              propData={propData}
              setApiTrigger={setApiTrigger}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
}


